// extracted by mini-css-extract-plugin
export default {"select_input":"Workspaces_select_input__xqVHE"};